module.exports = __webpack_public_path__ + "img/5.f19ea916.svg";